var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bg-column-wrapper',{attrs:{"label":_vm.label,"sort":_vm.sort,"visible":_vm.visible}},[_vm._t("default",function(){return [_vm._v("—")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }